// extracted by css-extract-rspack-plugin
export default {"pageShell":"vz89q6PnVE9GwB1g","loadingBar":"Szi4xiyQH8aV1z8c"};